var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"frame",staticClass:"monaco-editor-frame",style:(_vm.frameStyle)},[_c('div',{ref:"container",staticClass:"monaco-editor-host"})])
}
var staticRenderFns = []

export { render, staticRenderFns }